export default "__VITE_ASSET__pfI9HiTY__"